import React from "react";
import TextInput from "../input/TextInput";
import SelectInput from "../input/SelectInput";
import CheckBoxInput from "../input/CheckBoxInput";

interface Question {
    Type: string;
    Question: string;
    Answer?: string;
    placeholder?: string;
    errorMessage?: string;
    Options?: string[];
    checked?: boolean;
}

interface ExtraQuestionsProps {
    questions: Question[];
    onChange: (updated: Question[]) => void;
    disabled?: boolean;
}

function ExtraQuestions({ questions = [], onChange, disabled }: ExtraQuestionsProps) {
    if (!questions || !Array.isArray(questions)) return null;

    const updateAnswer = (index: number, updater: Partial<Question>) => {
        const updated = [...questions];
        updated[index] = {
            ...updated[index],
            ...updater,
        };
        onChange?.(updated);
    };

    return (
        <>
            {questions.map((question, index) => (
                <div key={index} className="my-4">
                    {question.Type === "text" && (
                        <TextInput
                            labelName={question.Question}
                            inputName={`question-${index}`}
                            placeholder={question.placeholder || ""}
                            onChange={(e) => updateAnswer(index, { Answer: e.target.value })}
                            value={question.Answer || ""}
                            errorMessage={question.errorMessage || ""}
                            type="text"
                            disabled={disabled}
                        />
                    )}
                    {question.Type === "select" && (
                        <SelectInput
                            labelName={question.Question}
                            inputName={`question-${index}`}
                            options={question.Options?.map((option) => ({ ID: option, Name: option })) || []}
                            placeholder={question.placeholder || ""}
                            onChange={(e) => updateAnswer(index, { Answer: e.target.value })}
                            value={question.Answer || ""}
                            errorMessage={question.errorMessage || ""}
                            disabled={disabled}
                        />
                    )}
                    {question.Type === "checkbox" && (
                        <CheckBoxInput
                            labelName={question.Question}
                            inputName={`question-${index}`}
                            value="yes"
                            checked={question.Answer === 'yes'}
                            setChecked={() => {
                                updateAnswer(index, {
                                    checked: !question.checked,
                                    Answer: question.checked ? "no" : "yes",
                                });
                            }}
                            disabled={disabled}
                        />
                    )}
                </div>
            ))}
        </>
    );
}

export default ExtraQuestions;